import React from 'react';

const AppContext = React.createContext({}); // added this
export default AppContext;
